import { QueryClient, useQueryClient } from "react-query";

export const invalidateAccreditationGroups = (
  queryClient: QueryClient,
  groupId: number
) => {
  queryClient.invalidateQueries(["groups"]);
  queryClient.invalidateQueries(["group", groupId.toString()]);
};
